import { render } from "./profile.vue?vue&type=template&id=2ce9691a&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=2ce9691a&lang=scss&scoped=true"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce9691a"]])

export default __exports__